import React, { useState, useEffect } from 'react'; // Added useEffect
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import AboutUs from '../AboutUs/AboutUs';
import FAQSection from './FAQSection/FAQSection';
import TeamGrid from '../Team/TeamGrid';
import TeamJoinForm from '../Team/TeamJoinForm';
import ContactStack from '../ContactPage/ContactPage';



const FullAbout = () => {
  // 1. Declare state INSIDE the function
  const [showContact, setShowContact] = useState(false);

    // FORCE SCROLL TO TOP ON LOAD
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <>
    <div className="about-page-wrapper" id="about">
      <Navbar />
      <div>
        <AboutUs/>
      </div>

      
      {/* <BrandPurposeSection/> */}
    {/*   <CraftingBrands/> */}
      <FAQSection/>
      <TeamGrid />
      <TeamJoinForm />
      {/* 2. Pass the trigger to Footer */}
      <Footer onContactClick={() => setShowContact(true)} />

      {/* 3. Render the Stack here */}
      {showContact && (
        <ContactStack onClose={() => setShowContact(false)} />
      )}

    </div>
    </>
  );
};

export default FullAbout;